import PointsHandler from './PointsHandler';

export default PointsHandler;
